import { render, staticRenderFns } from "./jiansuo.vue?vue&type=template&id=1b83ae58&scoped=true&"
import script from "./jiansuo.vue?vue&type=script&lang=js&"
export * from "./jiansuo.vue?vue&type=script&lang=js&"
import style0 from "./jiansuo.vue?vue&type=style&index=0&id=1b83ae58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83ae58",
  null
  
)

export default component.exports